<app-view-item *ngIf="readonly" [text]="displayText" [borderless]="borderless"></app-view-item>

<nz-select 
    *ngIf="!readonly" 
    [nzDisabled]="allowEdit === false" 
    [(ngModel)]="value" 
    [nzBorderless]="borderless"
    (ngModelChange)="onModelChange($event)" 
    [nzDropdownMatchSelectWidth]="false" 
    nzAllowClear="false" 
    class="width-100">
    <nz-option [nzValue]="item.value" [nzLabel]="item.label" *ngFor="let item of exemptedRateOptions"></nz-option>
</nz-select>